




































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class PaginationPanel extends Vue {
    @Prop({
        default: false,
    })
    public isDashboard: boolean;
    @Prop({
        default: 0,
    })
    public total: number;
    @Prop({
        default: false,
    })
    public reset: boolean;
    public paginationOptions = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public pageSizes = [10, 30, 50, 100];
    public lastPageNum = 0;
    public pageSize: number = 10;
    @Prop()
    public pageType;
    /* 重置当前页 */
    @Watch('reset')
    public reloadChange(val: boolean) {
        if (val) {
            this.paginationOptions.currentPage = 1;
        }
    }
    @Watch('total')
    public totalChange(newVal, oldVal) {
        this.total = newVal;
        this.lastPageNum = Math.ceil(newVal / this.paginationOptions.count);
    }

    mounted() {
        document.getElementsByClassName('el-pagination__jump')[0].childNodes[0].nodeValue = '跳至';
        if (document.getElementsByClassName('el-pagination__jump')[1]) {
            document.getElementsByClassName('el-pagination__jump')[1].childNodes[0].nodeValue = '跳至';
        }
        switch (this.pageType) {
            case 'CostAudit':
                this.paginationOptions.count = Number(sessionStorage.getItem('Pagination_val'))
                    ? Number(sessionStorage.getItem('Pagination_val'))
                    : 10;
                this.pageSize = this.paginationOptions.count ? this.paginationOptions.count : 10;
                break;
            case 'CostDetail':
                this.paginationOptions.count = Number(sessionStorage.getItem('Pagination1_val'))
                    ? Number(sessionStorage.getItem('Pagination1_val'))
                    : 10;
                this.pageSize = this.paginationOptions.count ? this.paginationOptions.count : 10;
                break;
            case 'CostStatement':
                this.paginationOptions.count = Number(sessionStorage.getItem('Pagination2_val'))
                    ? Number(sessionStorage.getItem('Pagination2_val'))
                    : 10;
                this.pageSize = this.paginationOptions.count ? this.paginationOptions.count : 10;
                break;

            default:
                break;
        }
    }
    setNowPage(num) {
        this.pageSize = num;
        this.paginationOptions.count = num
    }
    setPage(num) {
        this.paginationOptions.currentPage = num;
    }

    resetSize() {
        this.pageSizes = [10];
        this.$nextTick(() => {
            this.pageSizes = [10, 30, 50, 100];
        });
    }

    public firstPageBtnDisabled = true;
    public lastPageBtnDisabled = false;

    public handleCurrentChange(val) {
        console.log('onPaginationChange', val);
        this.firstPageBtnDisabled = val === 1 ? true : false;
        this.lastPageBtnDisabled = val === Math.ceil(this.total / this.paginationOptions.count) ? true : false;
        this.paginationOptions.currentPage = val;
        this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        console.log('this.paginationOptions~', this.paginationOptions);
        this.$emit('onPaginationChange', this.paginationOptions);
    }
    public handleSizeChange(val) {
        console.log('handleSizeChangeval' + JSON.stringify(val));
        switch (this.pageType) {
            case 'CostAudit':
                sessionStorage.setItem('Pagination_val', val);
                break;
            case 'CostDetail':
                sessionStorage.setItem('Pagination1_val', val);
                break;
            case 'CostStatement':
                sessionStorage.setItem('Pagination2_val', val);
                break;

            default:
                break;
        }
        this.paginationOptions.count = val;
        this.paginationOptions.currentPage = 1;
        this.handleCurrentChange(this.paginationOptions.currentPage);
        if (Math.ceil(this.total / val) < this.paginationOptions.currentPage) {
            this.paginationOptions.skip = 0;
        } else {
            this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
            this.$emit('onPaginationChange', this.paginationOptions);
        }
    }

    toFirstPage() {
        this.handleCurrentChange(1);
    }
    toLastPage() {
        this.paginationOptions.currentPage = Math.ceil(this.total / this.paginationOptions.count);
        this.handleCurrentChange(this.paginationOptions.currentPage);
    }
}
